module.exports = __webpack_public_path__ + "img/3.5.b29cbe8d.png";